/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdatePaymentRecordDto = {
    /**
     * Associated sales order ID
     */
    orderId?: number;
    /**
     * Payment method
     */
    method?: UpdatePaymentRecordDto.method;
    /**
     * Expected payment amount
     */
    amountExpected?: number;
    /**
     * Actual amount paid
     */
    amountPaid?: number;
    /**
     * Change given
     */
    changeGiven?: number;
};
export namespace UpdatePaymentRecordDto {
    /**
     * Payment method
     */
    export enum method {
        CASH = 'CASH',
        QR = 'QR',
        CARD = 'CARD',
    }
}

